// extracted by mini-css-extract-plugin
export default {"control":"Radio__control--3V2","content":"Radio__content--1Gc"};